import React from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
import { appendScriptsCallback } from '../../../helpers/Utils';

export function MediaTypesBroadcastTypePage(): React.ReactElement {
  const currentSecurity = useSecurity('MediaTypes', 'BroadcastType');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(["Areas/MediaTypes/Scripts/Resources/en/res.BroadcastType.en.js",
        "Areas/MediaTypes/Scripts/Resources/en/Types.en.js",
        "Areas/MediaTypes/Scripts/Enums.js",
        "Areas/MediaTypes/Scripts/BroadcastType/Index.js"], "initMediaTypesBroadcastType", {});
    }
  }, []);
  return (
    <div className="container-fluid">
      <header className="complete-grid">
        <div id="gridFilter1">
          <div id="gridfilter-toolbar"></div>
        </div>
      </header>
      <section id="gridContainer"></section>
      <ul id="gridContainer-menu"></ul>
    </div>
  );
}
